import { Grubenhund } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesSalzW({ currentMuseumId }) {
  const { grubenhund } = Grubenhund();

  const artefactArray = [grubenhund];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
